module.exports = __webpack_public_path__ + "img/money.61101361.svg";